import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

import { LearningPathHorizontalCard, TruncatedBox } from '@/components';
import {
  LearningPathsUtils,
  playerSessionsSelectors,
  selectUserCompliance,
  useAppSelector,
  useFetchEpisodeLearningPathsQuery,
} from '@/store';
import { Referrer } from '@/types';

export const RelatedLearningPaths = ({
  episodeId,
  referrer,
}: {
  episodeId: string;
  referrer: Referrer;
}) => {
  const compliance = useAppSelector(selectUserCompliance);
  const playerSessions = useAppSelector(playerSessionsSelectors.selectEntities);

  const { data: learningPaths } = useFetchEpisodeLearningPathsQuery({
    episodeId,
    compliance,
  });

  const learningPathsWithDuration = useMemo(() => {
    if (!learningPaths) return [];
    return LearningPathsUtils.calculateProgress({
      lps: learningPaths,
      playerSessions,
    });
  }, [playerSessions, learningPaths]);

  if (!learningPaths?.length) return null;

  return (
    <TruncatedBox>
      <Typography variant="h3" mb={2}>
        Related Learning Paths
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}>
        {learningPathsWithDuration.map((lp, index) => (
          <LearningPathHorizontalCard
            key={lp.groupId}
            learningPath={lp}
            referrer={{ ...referrer, position: index + 1 }}
          />
        ))}
      </Box>
    </TruncatedBox>
  );
};
